import { get, getAll } from "../utilities/querySelector";


export const modalContainer = get( '.site-modal' );

export const closeButton = get( '[data-modal-close]', modalContainer );

const videoModalTriggers = getAll( '[data-video-src]' );
const videoModal = get( '[data-modal=video]', modalContainer );
const video = videoModal.firstElementChild;
videoModalTriggers.forEach( trigger => {
    trigger.addEventListener( 'click', () => {
        const videoSrc = trigger.dataset.videoSrc;
        if ( video.src !== videoSrc ) video.src = videoSrc;
        activate( 'video' );
        video.play();
    } );
} );
closeButton.addEventListener( 'click', () => {
    video.pause();
} );

closeButton.addEventListener( 'click', fadeout );

/**
 * "Activates" the specified modal, opening the modal in the process
 * @param {string} modalName
 */
export function activate( modalName ) {
    get( `[data-modal=${modalName}]`, modalContainer ).dataset.active = true;
    modalContainer.dataset.active = true;
    fadein();
}

/**
 * Sets the active state of all modals to false
 */
function deactivate() {
    modalContainer.dataset.active = false;
    getAll( `[data-active=true]`, modalContainer ).forEach( activeModal => activeModal.dataset.active = false );

    // Remove status of contact form
    get( '.wpcf7-form', modalContainer )?.reset();
}

/**
 * Opens the main modal up
 */
function fadein() {
    modalContainer.animate( {
        opacity: [0, 1]
    }, 350 );
}

function fadeout() {
    const animation = modalContainer.animate( {
        opacity: [1, 0]
    }, 350 );
    animation.addEventListener( 'finish', () => {
        deactivate();
    } );
}
